import { createFileRoute } from "@tanstack/react-router";
import OwnerEmailTemplatesPage from "@/pages/OwnerEmailTemplatesPage";

export const Route = createFileRoute("/_owner/owner/email-templates")({
  component: OwnerEmailTemplatesPage,
});
